import * as React from "react";

import { TableType, ViewableField } from "./viewableFields";

interface ViewableFieldsContextProps {
  getAllViewableFields: (tableTypes: TableType[]) => void;
  getByTableType: (tableType: TableType) => void;
  resetByTableType: (tableType: TableType) => Promise<void>;
  // setByTableType: (tableType: TableType, viewableFields: ViewableField[]) => void;
  updateByTableType: (tableType: TableType, viewableFields: ViewableField[], all?: boolean) => Promise<void>;
  projectRunConfigurationId: number;
  viewableFieldsByTableType: Map<TableType, ViewableField[]>;
}

const ViewableFieldsContext = React.createContext<ViewableFieldsContextProps>({
  getAllViewableFields: () => null,
  getByTableType: () => null,
  projectRunConfigurationId: 0,
  resetByTableType: () => Promise.resolve(),
  // setByTableType: () => {/* */},
  updateByTableType: () => Promise.resolve(),
  viewableFieldsByTableType: new Map<TableType, ViewableField[]>()
});

/**
 * Wraps a given component with a ViewableFieldsContext Consumer and passes the resulting props directly to the component.
 * @param Component The component to wrap.
 */
function withViewableFields<T>(Component: React.ComponentType<React.PropsWithChildren<T & ViewableFieldsContextProps>>): React.ComponentType<React.PropsWithChildren<T>> {
  class WithViewableFields extends React.PureComponent<T> {
    public render() {
      return (
        <ViewableFieldsContext.Consumer>
          {(contextProps) => (
            <Component {...this.props} {...contextProps} />
          )}
        </ViewableFieldsContext.Consumer>
      );
    }
  }

  return WithViewableFields;
}

export { ViewableFieldsContext, ViewableFieldsContextProps, withViewableFields };
